import { connect } from "react-redux";
import GarageHeader from "../components/MyGarage/GarageHeader";
import { ApplicationStore } from "../store";

export function mapStateToProps({ account, deal, onlineShopper }: ApplicationStore) {
    return {
        account,
        deal,
        open: onlineShopper.isDrawerOpen,
        tradePendingOpen: onlineShopper.tradePendingOpen,
    };
}

export default connect(mapStateToProps)(GarageHeader);
